import styled from '@emotion/styled';
import { ButtonV3 } from '@zola/zola-ui/src/components/ButtonV3';
import Chip from '@zola/zola-ui/src/components/Chip';
import { LinkV2 } from '@zola/zola-ui/src/components/LinkV2';
import SkeletonLoader from '@zola/zola-ui/src/components/SkeletonLoader';
import MEDIA_QUERY_V2 from '@zola/zola-ui/src/styles/emotion/mediaQueryV2';
import SPACING from '@zola/zola-ui/src/styles/emotion/spacing';
import utils from '@zola/zola-ui/src/styles/emotion/utils';

export const Container = styled.section`
  padding: ${SPACING.S32} 0;
  text-align: center;

  ${MEDIA_QUERY_V2.EXCLUDE_MOBILE} {
    padding: 56px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
`;

export const TitleContainer = styled.div`
  margin: auto;

  ${MEDIA_QUERY_V2.EXCLUDE_DESKTOP} {
    max-width: 355px;
  }
`;

export const ThemeTiles = styled.div`
  display: grid;
  column-gap: ${SPACING.S48};
  row-gap: ${SPACING.S32};

  ${MEDIA_QUERY_V2.MOBILE} {
    row-gap: ${SPACING.S24};
  }

  ${MEDIA_QUERY_V2.TABLET} {
    grid-template-columns: repeat(2, auto);
  }

  ${MEDIA_QUERY_V2.DESKTOP} {
    grid-template-columns: repeat(3, auto);
  }
`;

export const ThemeMotifChips = styled.div`
  display: flex;
  gap: ${SPACING.XS};
  overflow: auto;
  margin: ${SPACING.S32} 0;
  ${utils.concealScrollbars}

  ${MEDIA_QUERY_V2.MOBILE} {
    margin: ${SPACING.S24} 0;
    padding: 0 ${SPACING.S24};
  }
`;

export const ThemeMotifChip = styled(Chip)`
  white-space: nowrap;
  ${MEDIA_QUERY_V2.DESKTOP} {
    padding: ${SPACING.XS} ${SPACING.S16};
  }
`;

export const StyledButton = styled(ButtonV3)`
  margin-top: ${SPACING.S32};

  ${MEDIA_QUERY_V2.MOBILE} {
    margin-top: ${SPACING.S24};
  }
`;

export const StyledLink = styled(LinkV2)`
  opacity: 0;
  position: absolute;
  bottom: -${SPACING.S16};
  left: 50%;
  transform: translate(-50%);
  width: 100%;
`;

export const PhotoLinkWrapper = styled.a`
  transition: all 0.2s ease-in-out;
  width: fit-content;

  ${MEDIA_QUERY_V2.EXCLUDE_MOBILE} {
    width: auto;
  }
`;

export const StyledSkeletonLoader = styled(SkeletonLoader)`
  margin: auto;
  width: 300px;
  height: 180px;

  ${MEDIA_QUERY_V2.DESKTOP_LG} {
    width: 350px;
    height: 210px;
  }
`;

export const TileWrapper = styled.div<{ hideOnMobile: boolean }>`
  display: flex;
  flex-direction: column;
  height: fit-content;
  position: relative;

  ${MEDIA_QUERY_V2.MOBILE} {
    display: ${({ hideOnMobile }) => (hideOnMobile ? 'none' : 'block')};
  }

  ${MEDIA_QUERY_V2.DESKTOP} {
    &:hover {
      ${StyledLink} {
        display: block;
        transition: opacity 0.5s;
        opacity: 1;
      }
      ${PhotoLinkWrapper} {
        transform: scale(1.1);
      }
    }
  }
`;

export const StyledImage = styled.img`
  object-fit: cover;
  height: 100%;
  width: 100%;
  max-width: 304px;

  ${MEDIA_QUERY_V2.DESKTOP} {
    max-width: 357px;
  }

  ${MEDIA_QUERY_V2.DESKTOP_XL} {
    max-width: 386px;
  }
`;
